import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Header';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

const CLASS = {
    OPEN: 'is-open'
}

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-toggle-nav', (e) => this.toggleNav());
        this.$el.on(EVENT.CLICK, '.js-toggle-dropdown', (e) => this.toggleDropdown(e));
        $('.js-header-bg').on(EVENT.CLICK, (e) => this.closeDropdown(e));
    }

    toggleNav() {
        $html.toggleClass('has-nav-open');
    }

    toggleDropdown(e) {
        const $target = $(e.currentTarget);
        const dropdown = $target.data('dropdown')
        const $parent = $target.parent();

        if (dropdown != 'mobile' || window.matchMedia('(max-width: 999px)').matches) {
            let $dropdown = $parent.find('.js-nav-dropdown').first();

            if($parent.hasClass(CLASS.OPEN)) {
                $parent.removeClass(CLASS.OPEN);
                $dropdown.stop().slideUp();
            } else {
                $parent.siblings('.js-nav-section.is-open').removeClass('is-open').children('.js-nav-dropdown').stop().slideUp();
                $parent.addClass(CLASS.OPEN);
                $dropdown.stop().slideDown();

                setTimeout(() => {
                    $('.js-header-nav').animate({ scrollTop: $parent.offset().top - $('.js-header').height() + $('.js-header-nav').scrollTop() }, 300);
                },600);
            }
        } else {
            if ($html.hasClass('is-ios')) {
                if ($parent.hasClass('js-nav-main-section')) {
                    if ($parent.hasClass('is-open')) {
                        $parent.removeClass('is-open');
                        $('.js-header-bg').removeClass('is-open');
                    } else {
                        $('.js-nav-main-section.is-open').removeClass('is-open');
                        $parent.addClass('is-open');
                        $('.js-header-bg').addClass('is-open');
                    }
                }
            }
        }
    }

    closeDropdown() {
        $('.js-header-bg').removeClass('is-open');
        $('.js-nav-main-section').removeClass('is-open');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
